let analyticsService: any = null;

export const clickSelfieScreenHandler = async event => {
  if (window['AIBA'] && window['AIBA']['utils']) {
    const handlers = window['AIBA']['utils'];
    await handlers.getNextJourney('selfie_intro_screen');
    analyticsService = handlers.analyticsService;
    event['data'] = { label: '' };
    event['virtualAgent'] = 'skin analysis - take quiz';
    analyticsService?.registerEvent('event16', event);
  }
};

export const handlOnLoad = async data => {
  if (window['AIBA'] && window['AIBA']['utils']) {
    const handlers = window['AIBA']['utils'];
    analyticsService = handlers.analyticsService;
    await handlers.setFlagSkipSelfieJourney(false);
    analyticsService?.registerEvent('event1', { page: 'Aiba Selfie privacy consent screen' });
    return data;
  }
};

export const handleCheckBox = async (checked,event) => {
  if (window['AIBA'] && window['AIBA']['utils']) {
    const handlers = window['AIBA']['utils'];
    console.log(event);
    await handlers.setConsentCheckedValue(checked);
  }};